import React, { useEffect } from 'react';
import './Applications.css';
import { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import AQuAA_DXC_Logo from './../assets/application-image/AQuAA_DXC_Logo.png';
import ICED_DXC_Logo from './../assets/application-image/ICED_DXC_Logo.png';
import Heatmap_DXC_Logo from './../assets/application-image/Heatmap_DXC_Logo.png';
import Dashboards_DXC_Logo from './../assets/application-image/Dashboards_DXC_Logo.png';

import { getRoleBasedView } from '../actions/Administration/admin.action';
import { useDispatch, useSelector } from 'react-redux';





const Applications = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const RoleBasedView = useSelector((state) => state.adminAccountReducer.RoleBasedView);
            useEffect(() => {
                dispatch(getRoleBasedView())
            }, [dispatch])


    const Apps = [
    {
        id: 1,
        "description": "AQuAA",
        path:'/aquaaapplications',
        img:AQuAA_DXC_Logo
    },
    {
        id: 2,
        "Name": "ICED",
        // "description": "Incident Contact Effort Data",
        description:"ICED",
        path:'/icedapplications',
        img:ICED_DXC_Logo
    },
    {
        id: 3,
        "Name": "Heatmap",
        "description": "Heatmap",
        path:'/heatmap',
        img:Heatmap_DXC_Logo,
         visible: RoleBasedView?.[0]?.['HeatMap ReadWrite']?.[0]?.ReadWrite
    },
    {
        id: 4,
        "Name": "Dashboard",
        "description": "Dashboard",
        img:Dashboards_DXC_Logo,
        external: true,
        link: "https://nam12.safelinks.protection.outlook.com/?url=https%3A%2F%2Fapp.powerbi.com%2FRedirect%3Faction%3DOpenApp%26appId%3D966f0aaa-2848-44ba-8a69-766423791e33%26ctid%3D93f33571-550f-43cf-b09f-cd331338d086%26experience%3Dpower-bi&data=05%7C02%7Cmveerla%40dxc.com%7Cfa8091e382474ed3d75808de7887e196%7C93f33571550f43cfb09fcd331338d086%7C0%7C0%7C639080722171285558%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=XNK9%2Fo2SvfXOD%2B31Y2bVaPOALgXSwIM9boyZ%2F0tpb9A%3D&reserved=0"
    },
    // {
    //     id: 4,
    //     "Name": "APP 3",
    // }
]

const handleAppClick = (app) => {
  if (app.external) {
    window.open(app.link, "_blank"); // opens SharePoint in new tab
  } else {
    history.push(app.path);
  }
};
   
    return (
        <Fragment>
            {/* <div className='App_Layout' style={{flexWrap:'wrap'}}>
              {Apps.map((App,i) => (
               <> <div className='App_cards' onClick={()=>history.push(App.path)}><img src={App.img} alt='' height='200px' width='200px'/>
               <div>{App.Name}</div> </div>  </>))  }
            </div> */}

            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
  {Apps
    .filter(app => app.visible === 1 || app.visible === undefined)
    .map((app) => (

      <div
        className="App_cards"
        key={app.id}
       onClick={() => handleAppClick(app)}
        style={{ cursor: 'pointer' }}
      >
        {app.img ? (
          <img src={app.img} alt="" height="200px" width="200px" />
        ) : (
          <div
            style={{
              height: '200px',
              width: '200px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '24px',
              fontWeight: 'bold',
              border: '1px solid #ccc',
              color: '#004aac'
            }}
          >
            {app.Name}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', color: '#004aac' }}>
          {app.description}
        </div>
      </div>

  ))}
</div>
{/* <iframe title="AQuAA" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=d3755912-3cbf-4dc5-8679-f274f1589909&autoAuth=true&embeddedDemo=true" frameborder="0" allowFullScreen="true"></iframe> */}
        </Fragment>
    )
}

export default Applications